/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
export default {
  name: 'public-models',
  components: {
  },
  props: [],
  data () {
    return {
      createdAlgoList:null,
      createdAlgoListResults:[],
      pubModelId:'',
      publicModelPopup:false,
      userDetails:null,
      updateModelName:'',
      updateModelNameId:'',
      updateModelNameState:false,
      sharedModelInfo:null,
      sharedModelPopup:false,
      submitted:false
    }
  },
  computed: {
  },
  mounted () {
    this.getCreatedModelsListFunc();
  },
  methods: {
    getCreatedModelsListFunc() {
      this.$store.dispatch('getPublicModelListForAITaskFun').then((res) => {
        this.createdAlgoList = res.data.data
        this.createdAlgoListResults = this.createdAlgoList.results 
      })
    },
  },
  watch:{
  }
}